export const disableContextMenu = {
  mounted(el) {
    el.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });
  }
};
